import { api } from "@/lib/api";

/**
 * Menu Designer API — thin wrapper around the backend routes so the pages
 * stay uncluttered. All calls go through the shared axios instance which
 * already handles auth headers and error toasts.
 */
export const menuApi = {
  // Templates (Admin creates, all users read active ones)
  listTemplates: () => api.get("/menu-templates").then((r) => r.data),
  getTemplate: (id) => api.get(`/menu-templates/${id}`).then((r) => r.data),
  createTemplate: (formData) =>
    api.post("/admin/menu-templates", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data),
  updateTemplate: (id, body) => api.patch(`/admin/menu-templates/${id}`, body).then((r) => r.data),
  deleteTemplate: (id) => api.delete(`/admin/menu-templates/${id}`).then((r) => r.data),

  // Menus (user-owned)
  listMenus: () => api.get("/menus").then((r) => r.data),
  getMenu: (id) => api.get(`/menus/${id}`).then((r) => r.data),
  createMenu: (body) => api.post("/menus", body).then((r) => r.data),
  updateMenu: (id, body) => api.put(`/menus/${id}`, body).then((r) => r.data),
  deleteMenu: (id) => api.delete(`/menus/${id}`).then((r) => r.data),
  duplicateMenu: (id) => api.post(`/menus/${id}/duplicate`).then((r) => r.data),
  trackExport: (id, format) => api.post(`/menus/${id}/track-export`, { format }).then((r) => r.data),
};
